import React from 'react'
import NoContent from "./NoContent";
import Helper from 'src/support/Helper';
import HCLDX from "@system/config/hcldx";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import AxiosIndicatorRunTimeLoader from '../AxiosIndicatorRunTimeLoader';

const Categories = (props) => {
    const { categoriesList, searchText, apiCall } = props;
    const [__check] = useAxiosIndicatorCheck();

    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Categories", obj?.main_label, (HCLDX.baseURL() + obj?.Url))
    }
    const listMaker = (v, i) => {
        return (
            <React.Fragment key={i}>
                <li onClick={() => typeHeadSearchEvent(v)} style={{ display: 'block' }}>
                    <a href={HCLDX.baseURL() + v.Url}
                        style={{
                            cursor: 'pointer',
                            fontWeight: v.Level === 1 ? '' : ''
                        }}
                    >{v.main_label} </a>
                </li>
                {v.Categories !== undefined && v.Categories.length > 0 &&
                    v.Categories.map((v_in, i_in) => (
                        <> {listMaker(v_in, i_in)} </>
                    ))}
            </React.Fragment>
        );
    };

    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Categories</div>
            {__check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status && !apiCall.Category ?
                <AxiosIndicatorRunTimeLoader />
                : <>
                    <div className='search-product-list'>
                        <ul className="hierarchical categories-list">
                            {categoriesList.length > 0 ?
                                <>
                                    {categoriesList.map((v, i) => (
                                        <React.Fragment key={Helper.UUID()}>
                                            {listMaker(v, i)}
                                        </React.Fragment>
                                    ))}
                                </>
                                : <NoContent />
                            }
                        </ul>
                    </div>
                </>
            }
        </>
    )
}

export default Categories